import React from 'react'
import { SummaryCardProps } from './types'

export default function SummaryCard({
    alt,
    imagePc,
    imageSp,
    className,
    isSp = false,
}: SummaryCardProps & { isSp?: boolean }) {
    return (
        <li className={className}>
            <img src={isSp ? imageSp : imagePc} alt={alt} />
        </li>
    )
}
